'use client';
import { useLocationStore, useMapControl } from '@ahm/react-map/store';
import { ActionIcon, Card, useMantineColorScheme } from '@mantine/core';
import { closeAllModals } from '@mantine/modals';
import { X } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useLocale } from 'next-intl';
import PathDnd from '@/features/booking/components/paths/path-dnd';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

const MapView = dynamic(
  () => import('@ahm/react-map').then((mod) => mod.MapView),
  {
    ssr: false,
  }
);

const MapPaths = dynamic(
  () => import('@ahm/react-map').then((mod) => mod.MapPaths),
  {
    ssr: false,
  }
);

const MapAutoFitBounds = dynamic(
  () => import('@ahm/react-map').then((mod) => mod.MapAutoFitBounds),
  {
    ssr: false,
  }
);

const MapPolyline = dynamic(
  () => import('@ahm/react-map').then((mod) => mod.MapPolyline),
  {
    ssr: false,
  }
);

export default function ModalDndPath() {
  const curLocale = useLocale() as 'vi' | 'en';
  const isMobile = useIsMobile();
  const { colorScheme } = useMantineColorScheme();
  const paths = useLocationStore.use.paths();
  const setPaths = useLocationStore.use.setPaths();
  const { estimatedData } = useBookingStore((state) => state);

  const centerCoords = useMapControl.use.centerCoords();

  // const handleSubmitDnd = (sortedIndexes: number[] | null) => {
  //   if (sortedIndexes && sortedIndexes.length === paths.length) {
  //     const newPaths = sortedIndexes.map((idx) => paths[idx]);
  //     setPaths(newPaths);
  //   }
  // };

  const handleSubmitDnd = (sortedIndexes: number[]) => {
    if (!sortedIndexes) {
      handleClose();
      return;
    }

    const newPaths = sortedIndexes.map((idx) => paths[idx]);

    if (sortedIndexes[0] !== 0) {
      newPaths.forEach((path) => (path.cod = undefined));
    }

    setPaths(newPaths);
    handleClose();
  };

  const handleClose = () => {
    // closeModal(ModalName.DndPath);
    closeAllModals();
  };

  if (isMobile)
    return (
      <>
        <ActionIcon
          size={44}
          variant="transparent"
          pos="absolute"
          top={20}
          left={isMobile ? 0 : 'calc(100% - 44px)'}
          onClick={handleClose}
          style={{ outline: 'none !important', zIndex: 10 }}
        >
          <X
            size={24}
            color={
              colorScheme === 'dark'
                ? 'var(--mantine-color-neutral-2)'
                : 'var(--mantine-color-neutral-6)'
            }
          />
        </ActionIcon>
        <Card p={0} radius="md" h={'40vh'} w="100%">
          <MapView
            id="booking-map-modal"
            centerCoords={centerCoords}
            disableType={undefined}
            lang={curLocale}
          >
            <MapPaths paths={paths} disable={undefined} lang={curLocale} />

            {estimatedData?.data?.polylines ? (
              <MapPolyline
                id="booking-map-polylines"
                polyString={estimatedData?.data?.polylines}
                distance={estimatedData?.data?.distance}
                animate
              />
            ) : null}
            <MapAutoFitBounds centerCoords={centerCoords} path={paths} />
          </MapView>
        </Card>

        <PathDnd
          opened={true}
          handleClose={handleClose}
          onSubmit={handleSubmitDnd}
        />
      </>
    );
}
